export default "__VITE_ASSET__BATzHuMU__"